import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/views/layout/Layout'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', component: () => import('@/views/dashboard/index'), meta: { title: '仪表盘', icon: 'el-icon-s-data' } },
      { path: 'users', component: () => import('@/views/user/index'), meta: { title: '用户管理', icon: 'el-icon-user' } },
      { path: 'whitelist', component: () => import('@/views/user/whitelist'), meta: { title: '白名单管理', icon: 'el-icon-document' } },
      { path: 'classes', component: () => import('@/views/class/index'), meta: { title: '班级管理', icon: 'el-icon-school' } },
      { path: 'font-library', component: () => import('@/views/font-library/index'), meta: { title: '字体库管理', icon: 'el-icon-edit' } },
      { path: 'writing-records', component: () => import('@/views/writing-record/index'), meta: { title: '书写记录', icon: 'el-icon-document-copy' } },
      { path: 'writing-records/:id', component: () => import('@/views/writing-record/detail'), meta: { title: '评分详情', icon: 'el-icon-document-copy' } },
      { path: 'homework', component: () => import('@/views/homework/index'), meta: { title: '作业管理', icon: 'el-icon-notebook-1' } },
      { path: 'exam-questions', component: () => import('@/views/exam/question'), meta: { title: '题库管理', icon: 'el-icon-question' } },
      { path: 'exam-configs', component: () => import('@/views/exam/config'), meta: { title: '考试配置', icon: 'el-icon-setting' } },
      { path: 'courses', component: () => import('@/views/course/index'), meta: { title: '课程管理', icon: 'el-icon-reading' } },
      { path: 'videos', component: () => import('@/views/video/index'), meta: { title: '视频管理', icon: 'el-icon-video-camera' } },
      { path: 'scoring-params', component: () => import('@/views/system/scoring-params'), meta: { title: '评分参数', icon: 'el-icon-s-operation' } },
      { path: 'system-config', component: () => import('@/views/system/basic'), meta: { title: '基础配置', icon: 'el-icon-s-tools' } },
      { path: 'scheduled-tasks', component: () => import('@/views/system/scheduled-tasks'), meta: { title: '定时任务', icon: 'el-icon-time' } },
      { path: 'api-logs', component: () => import('@/views/system/api-log'), meta: { title: '接口日志', icon: 'el-icon-document' } },
      { path: 'puma-logs', component: () => import('@/views/system/puma-log'), meta: { title: '辅码日志', icon: 'el-icon-document' } },
      { path: 'roles', component: () => import('@/views/role/index'), meta: { title: '角色管理', icon: 'el-icon-lock' } },
      { path: 'menus', component: () => import('@/views/menu/index'), meta: { title: '菜单管理', icon: 'el-icon-menu' } },
      { path: 'puma', component: () => import('@/views/puma/index'), meta: { title: '铺码管理', icon: 'el-icon-printer' } },
      { path: 'grid-sheet', component: () => import('@/views/grid-sheet/index'), meta: { title: '字帖生成', icon: 'el-icon-s-grid' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title + ' - 中文书写评分系统' : '中文书写评分系统'
  if (to.path !== '/login' && !getToken()) {
    next('/login')
  } else {
    next()
  }
})

export default router
